// Do not modify, this file was generated
// to modify, reference the files in dibs-sassy/src/colors/*

export const colors = {
    sassyColorAlertPrimary: '#CC0000',
    sassyColorAlertSecondary: '#950808',
    sassyColorAlertTertiary: '#FEDCDE',
    sassyColorWarningPrimary: '#F07F04',
    sassyColorWarningSecondary: '#FFC100',
    sassyColorSuccessPrimary: '#66a559',
    sassyColorSuccessSecondary: '#2A7140',
    sassyColorSuccessTertiary: '#aedfa3',
    sassyColorBuyerPrimary: '#C2A661',
    sassyColorBuyerSecondary: '#A48E45',
    sassyColorBuyerTertiary: '#F6F3EB',
    sassyColorBuyerTertiaryAlt: '#E8DFCD',
    sassyColorBuyerPrimaryIphone: '#CCA738',
    sassyColorDealerPrimary: '#436B93',
    sassyColorDealerSecondary: '#204664',
    sassyColorDealerTertiary: '#DEE3EB',
    sassyColorDealerTertiaryAlt: '#D8ECF5',
    sassyColorWhite: '#FFF',
    sassyColorAlabaster: '#FBFBFB',
    sassyColorMoonstone: '#F3F3F3',
    sassyColorDolphin: '#DDD',
    sassyColorStorm: '#BBB',
    sassyColorIron: '#888',
    sassyColorSatan: '#666',
    sassyColorCharcoal: '#444',
    sassyColorNoir: '#222',
    sassyColorPitchBlack: '#000',
    sassyColorOverlayBackground: 'rgba(0, 0, 0, 0.7)',
    sassyColorOverlayLight: 'rgba(255, 255, 255, 0.4)',
    sassyColorInternalPrimary: '#559B5E',
    sassyColorInternalSecondary: '#2A7140',
    sassyColorInternalTertiary: '#B8E7C8',
    sassyColorMarketingSale: '#950808',
    sassyColorNftWine: '#610034',
    sassyColorMutedAquamarine: '#AABEB9',
    sassyColorMedalBronze: '#a06931',
    sassyColorMedalSilver: '#637583',
    sassyColorMedalGold: '#8C7236',
    sassyColorMedalPlatinum: '#727383',
    sassyColorPinterestPrimary: '#E00002',
    sassyColorFacebookPrimary: '#3B5998',
    sassyColorInstagramPrimary: '#275A85',
    sassyColorLinkedinPrimary: '#007BB6',
    sassyColorTwitterPrimary: '#4099FF',
    sassyColorDesignManagerPrimary: '#4BC7E7',
    sassyColorDesignManagerSecondary: '#4F8BC0',
    sassyColorDesignManagerTertiary: '#45545F',
    sassyColorTradePrimary: '#0F8D88',
    sassyColorTradeSecondary: '#0D7D77',
    sassyColorTradeTertiary: '#E7F4F3',
    sassyColorTradeMember: '#666',
} as const;

export type SassyColorNames = keyof typeof colors;
export type SassyColorValues = (typeof colors)[SassyColorNames];
